import { defineComponent, ref, toRef, watch } from "vue";
import { usePopperjs } from "./usePopper";
export default defineComponent({
    components: {},
    props: {
        // hook options
        delayOnMouseout: Number,
        delayOnMouseover: Number,
        trigger: String,
        forceShow: Boolean,
        modifiers: Array,
        onFirstUpdate: Function,
        placement: String,
        strategy: String,
        // component props
        popperIs: {
            default: "div",
            type: String,
        },
        popperProps: {
            type: Object,
        },
        referenceIs: {
            default: "div",
            type: String,
        },
        referenceProps: {
            type: Object,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        darkMode: {
            type: Boolean,
            default: true,
        },
    },
    emits: [
        "show",
        "hide",
        "before-enter",
        "enter",
        "after-enter",
        "enter-cancelled",
        "before-leave",
        "leave",
        "after-leave",
        "leave-cancelled",
    ],
    setup(props, { emit }) {
        const reference = ref();
        const popper = ref();
        const { visible } = usePopperjs(reference, popper, Object.assign(Object.assign({}, props), { trigger: toRef(props, "trigger"), forceShow: toRef(props, "forceShow"), disabled: toRef(props, "disabled"), delayOnMouseover: toRef(props, "delayOnMouseover"), delayOnMouseout: toRef(props, "delayOnMouseout"), onShow: () => emit("show"), onHide: () => emit("hide") }));
        watch(() => [visible.value, props.disabled], () => {
            if (props.disabled && visible.value) {
                visible.value = false;
            }
        }, { flush: "sync" });
        const handle = (event) => (...args) => {
            return emit(event, ...args);
        };
        return {
            visible,
            reference,
            popper,
            handle,
        };
    },
});
